import type { Branded } from '@client/new/helpers/types';
import { ReactionParent, ReactionType } from 'generated/graphql';

export { ReactionParent, ReactionType };

export type PostId = Branded<string, 'PostId'>;
export type AuthorId = Branded<number, 'AuthorId'>;

export type MediaItemStatus = 'ready' | 'processing' | 'failed';

export type PostStatus = 'published' | 'processing';

export type PostMediaItem = {
  type: 'image' | 'video' | 'audio';
  url: string;
  thumbnailUrl: string;
  status: MediaItemStatus;
};

export type Reaction = {
  type: ReactionType;
  count: number;
  isToggled: boolean;
};

export type Post = {
  id: PostId;
  author: {
    id: AuthorId;
    name: string;
    avatarUrl: string;
    email: string | null;
    marketing: boolean | null;
    isOwn: boolean;
    isCreator: boolean;
    canReceiveDm: boolean;
  };
  createdAt: Date;
  content: string;
  edited: boolean;
  status: PostStatus;
  media: PostMediaItem[];
  reactions: Reaction[];
  commentCount: number;
  pinned: boolean;
};

export const toPostId = (value: string): PostId => value as PostId;

export const toAuthorId = (value: number): AuthorId => value as AuthorId;
